import { Button } from '@consigli/shadcn';
import { Finding } from '@consigli/types';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { FC, useState } from 'react';

import { FindingRow } from './summary-finding-row';

interface SectionAccordionProps {
  heading: string;
  body: string;
  findings: Finding[];
  findingCount: number;
}

export const SectionAccordion: FC<SectionAccordionProps> = ({
  heading,
  body,
  findings,
  findingCount,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <li className="list-none">
      <Button
        variant="ghost"
        className="flex items-start w-full px-5 py-3.5 text-left h-auto justify-start gap-2.5 bg-white rounded-none"
        onClick={() => setOpen((v) => !v)}
      >
        <span className="mt-1 shrink-0 text-gray-400">
          {open ? <ChevronDown size={11} /> : <ChevronRight size={11} />}
        </span>
        <span className="grow text-sm leading-snug min-w-0">
          <span className="inline-flex items-center gap-2 flex-wrap">
            <span className="font-semibold text-gray-800">{heading}</span>
            <span className="inline-flex items-center justify-center min-w-5 h-5 px-1 rounded-full bg-gray-100 text-xs font-medium text-gray-600 leading-none shrink-0">
              {findingCount}
            </span>
          </span>
          {body && (
            <span className="block mt-1 text-gray-500 text-xs leading-relaxed wrap-break-word whitespace-normal">
              {body}
            </span>
          )}
        </span>
      </Button>

      {open && findings.length > 0 && (
        <div className="bg-gray-50 border-t border-gray-200">
          <ul className="flex flex-col gap-2 px-5 py-4 pl-9">
            {findings.map((f) => (
              <FindingRow key={f.id} finding={f} />
            ))}
          </ul>
        </div>
      )}
    </li>
  );
};
